module.exports = __webpack_public_path__ + "img/ifta-2019.3fe811b7.jpg";